// src/ErrorBoundary.js
import { AlertTriangle, RefreshCw } from "lucide-react";
import React, { Component } from "react";
import { Link } from "react-router-dom";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError(error) {
    // Update state so the next render shows the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    // You can also log the error to an error reporting service
    console.error("Error occurred:", error, errorInfo);
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-h-screen tw-text-center tw-p-6">
          <AlertTriangle className="tw-w-12 tw-h-12 tw-text-red-500 tw-mb-4" />
          <h1 className="tw-text-2xl tw-font-bold tw-text-gray-800">
            Oops! Something went wrong.
          </h1>
          <p className="tw-text-gray-600 tw-mt-2 tw-mb-4">
            {this.state.errorMessage}
          </p>

          <Link to="/">
            <button
              // onClick={this.handleReload}
              className="tw-flex tw-items-center tw-gap-2 tw-bg-[#00B5ED] tw-text-white tw-font-semibold tw-py-2 tw-px-4 tw-rounded-md tw-transition hover:tw-opacity-80"
            >
              <RefreshCw className="tw-w-5 tw-h-5" />
              Reload Page
            </button>
          </Link>
        </div>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
